/* RESPONSIBLE TEAM: team-ai-insights */
import { type LogicalFilter } from 'embercom/components/reporting/custom/filters';
import { type FlexibleQueryTimeRange } from 'embercom/services/reporting-csv-export';
import ajax from 'embercom/lib/ajax';

interface InsightsSummary {
  text: string;
}

export interface InsightsSummaryResult {
  summary: {
    text: string;
  };
}

interface LoadInsightsSummaryArgs {
  appId: string;
  adminId: number;
  filter: LogicalFilter;
  timeRange: FlexibleQueryTimeRange;
  sortByAttributeId: string;
  sortDirection: 'asc' | 'desc';
  useSyntheticData: boolean;
  timezone: string;
}

export async function loadInsightsSummary({
  appId,
  adminId,
  filter,
  timeRange,
  sortByAttributeId,
  sortDirection,
  useSyntheticData,
  timezone,
}: LoadInsightsSummaryArgs): Promise<InsightsSummaryResult> {
  let params: Record<string, unknown> = {
    app_id: appId,
    admin_id: adminId,
    filter,
    time: timeRange,
    sort_by_attribute_id: sortByAttributeId,
    sort_direction: sortDirection,
    use_synthetic_data: useSyntheticData.toString(),
    time_zone: timezone,
  };

  let response = await ajax({
    url: '/ember/ai_insights/conversations_summary',
    type: 'POST',
    data: JSON.stringify(params),
  });

  return {
    summary: response.summary as InsightsSummary,
  };
}
